import React from 'react';
const pains = ['"Uso los óvulos, me pasa por 3 días y en una semana vuelve todo igual"', '"El ginecólogo me dice que soy \'propensa\' y me receta lo mismo de siempre"', '"Gasté más de $200.000 este año en consultas y tratamientos que no funcionan"', '"Evito las relaciones porque tengo miedo al dolor o a que mi pareja lo note"', '"Me hincho como si estuviera embarazada al final del día y no entiendo por qué"', '"Tengo antojos de dulce brutales a la tarde que no puedo controlar"', '"Siento que mi cuerpo está fallado y que esto es para siempre"'];
export function PainSection() {
  return <section className="w-full px-6 py-16 max-w-2xl mx-auto" data-id="element-176">
      <p className="text-brand-teal text-[11px] font-semibold uppercase tracking-widest mb-3" data-id="element-177">
        Esto te está pasando a vos
      </p>
      <h2 className="text-[24px] font-bold text-white mb-8 leading-tight" data-id="element-178">
        ¿Cuántas de estas frases te suenan?
      </h2>

      <div className="flex flex-col gap-3 mb-8" data-id="element-179">
        {pains.map((pain, i) => <div key={i} className="bg-white/[0.04] border-l-4 border-brand-magenta rounded-r-xl p-4" data-id="element-180">
            <p className="text-[15px] text-white/90 leading-relaxed" data-id="element-181">
              🔴 {pain}
            </p>
          </div>)}
      </div>

      <div className="rounded-xl p-5" style={{
      background: 'rgba(255,0,110,0.08)',
      border: '1px solid #FF006E'
    }} data-id="element-182">
        <p className="text-[15px] text-white leading-relaxed" data-id="element-183">
          Si marcaste aunque sea 2 de estas frases,{' '}
          <strong data-id="element-184">no es tu culpa.</strong> No es falta de higiene. Es un
          mecanismo biológico específico que ningún turno de 10 minutos tiene
          tiempo de explicarte.
        </p>
      </div>
    </section>;
}